<template>
  <div class="w-full">
    <div class="bg-white border min-h-[260px] border-gray-300 relative">
      <Listbox v-model="cardVersion" v-if="false">
        <div class="absolute top-4 right-4">
          <ListboxButton
            class="flex items-center w-fit cursor-pointer text-gray-500 hover:text-success"
          >
            <span class="mr-1 text-sm">vCard {{ cardVersion }}</span>
            <SettingsIcon size="16" stroke-width="1" />
          </ListboxButton>

          <transition
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <ListboxOptions
              class="absolute z-10 mt-1 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
              <ListboxOption
                v-slot="{ active, selected }"
                v-for="version in listCardVersions"
                :value="version"
                as="template"
              >
                <li
                  :class="[
                    active ? 'bg-success/10 text-success' : 'text-gray-900',
                    'relative cursor-default select-none py-2 pl-10 pr-4',
                  ]"
                >
                  <span
                    :class="[
                      selected ? 'font-medium' : 'font-normal',
                      'block truncate',
                    ]"
                    >{{ version }}</span
                  >
                  <span
                    v-if="selected"
                    class="absolute inset-y-0 left-0 flex items-center pl-3 text-success"
                  >
                    <CheckIcon class="h-5 w-5" aria-hidden="true" />
                  </span>
                </li>
              </ListboxOption>
            </ListboxOptions>
          </transition>
        </div>
      </Listbox>

      <div class="grid grid-cols-12 mt-8 px-4">
        <div class="col-span-12 sm:col-span-3 mb-4">
          <div class="flex items-center justify-center">
            <nuxt-img
              loading="lazy"
              v-if="!imageData"
              src="/icons/avatar.png"
              alt="sample-avatar"
              :width="64"
              class="cursor-pointer"
              @click="chooseAvatar()"
            />
            <img
              v-else
              :src="imageData"
              :width="64"
              :height="64"
              class="cursor-pointer rounded-full border border-gray-200"
            />
            <input
              type="file"
              accept="image/*"
              class="hidden"
              ref="file"
              @change="changeAvatar"
            />
          </div>
        </div>
        <div class="col-span-12 sm:col-span-8">
          <div class="mb-3" v-for="card in Cards">
            <div
              v-for="field in card.fields.filter((item) => item.status)"
              class="pt-3 pb-1.5 border-b border-b-gray-200 border-dashed flex items-center gap-3 relative"
              :class="{
                '!border-b-danger':
                  !field.value && field.required && validateVee,
              }"
            >
              <label
                for=""
                class="font-normal w-20 text-gray-400 text-[14px]"
                :class="{ required: field.required }"
                >{{ field.name }}</label
              >
              <template v-if="field.type == 'select'">
                <Listbox v-model="field.value">
                  <div class="relative w-full">
                    <ListboxButton
                      class="relative w-full cursor-pointer h-[22px] text-left"
                    >
                      {{ field.value }}
                    </ListboxButton>

                    <transition
                      leave-active-class="transition duration-100 ease-in"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <ListboxOptions
                        class="absolute z-10 mt-1 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                      >
                        <ListboxOption
                          v-slot="{ active, selected }"
                          v-for="gender in field.options"
                          :value="gender"
                          as="template"
                        >
                          <li
                            :class="[
                              active
                                ? 'bg-success/10 text-success'
                                : 'text-gray-900',
                              'relative cursor-default select-none py-2 pl-10 pr-4',
                            ]"
                          >
                            <span
                              :class="[
                                selected ? 'font-medium' : 'font-normal',
                                'block truncate',
                              ]"
                              >{{ gender }}</span
                            >
                            <span
                              v-if="selected"
                              class="absolute inset-y-0 left-0 flex items-center pl-3 text-success"
                            >
                              <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                          </li>
                        </ListboxOption>
                      </ListboxOptions>
                    </transition>
                  </div>
                </Listbox>
              </template>
              <template v-else>
                <input
                  :type="field.type"
                  :placeholder="field.placeholder"
                  v-model="field.value"
                  @click="validateVee = false"
                  class="h-[22px] border-none shadow-none placeholder-gray-300 outline-none focus:outline-none w-full"
                />
              </template>
              <span v-if="!field.default" class="absolute right-0 text-danger">
                <XIcon
                  class="w-5 cursor-pointer"
                  @click="clearField(field)"
                  aria-label="delete"
                />
              </span>
            </div>
            <template v-if="card.fields.find((item) => !item.status)">
              <Menu as="div" class="relative inline-block text-left">
                <MenuButton
                  class="flex items-center text-success-tier gap-2 cursor-pointer py-2"
                >
                  <CirclePlusIcon size="18" />
                  <span class="font-medium text-sm"> Add {{ card.name }} </span>
                </MenuButton>
                <transition
                  enter-active-class="transition duration-100 ease-out"
                  enter-from-class="transform scale-95 opacity-0"
                  enter-to-class="transform scale-100 opacity-100"
                  leave-active-class="transition duration-75 ease-in"
                  leave-from-class="transform scale-100 opacity-100"
                  leave-to-class="transform scale-95 opacity-0"
                >
                  <MenuItems
                    class="absolute z-10 left-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                  >
                    <div class="px-1 py-1">
                      <MenuItem
                        v-slot="{ active }"
                        v-for="field in card.fields.filter(
                          (item) => !item.status
                        )"
                        @click="field.status = true"
                      >
                        <button
                          :class="[
                            active ? 'bg-success text-white' : 'text-gray-900',
                            'group flex w-full items-center rounded-md px-2 py-2 text-sm',
                          ]"
                        >
                          {{ field.name }}
                        </button>
                      </MenuItem>
                    </div>
                  </MenuItems>
                </transition>
              </Menu>
            </template>
          </div>
        </div>
        <div class="col-span-1"></div>
      </div>
    </div>
    <div
      class="flex items-center justify-center xs:flex-row flex-col gap-4 mt-8"
    >
      <button
        @click="GenerateQrCode()"
        class="bg-success hover:bg-success-tier font-medium h-[44px] px-10 rounded-sm text-white text-center flex items-center justify-center"
      >
        {{ $t("gen_code") }}
      </button>
      <button
        @click="DownloadVcard()"
        class="bg-white border border-success font-medium h-[43px] px-10 rounded-sm text-success text-center flex items-center justify-center"
      >
        Download Vcard
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import moment from "moment";
import {
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { CirclePlusIcon, CheckIcon, SettingsIcon } from "vue-tabler-icons";
import XIcon from "~/assets/svg/x.svg?component";
import {
  AdrProperty,
  BdayProperty,
  BirthPlaceProperty,
  DateTimeType,
  EmailProperty,
  FNProperty,
  GenderProperty,
  GeoProperty,
  Group,
  HobbyProperty,
  IntegerType,
  LangProperty,
  LevelParameter,
  NProperty,
  NicknameProperty,
  NoteProperty,
  OrgProperty,
  PhotoProperty,
  PrefParameter,
  RoleProperty,
  SexType,
  SpecialValueType,
  TelProperty,
  TextType,
  TypeParameter,
  URIType,
  URLProperty,
  VCARD,
} from "vcard4";
import { useQrCreateStore } from "~~/stores/qrcreate";

interface CardGroup {
  name: string;
  fields: Array<FieldCard>;
}
interface FieldCard {
  name: string;
  type: string;
  value?: string;
  status?: boolean;
  required?: boolean;
  default?: boolean;
  placeholder?: string;
  options?: Array<string>;
}
const listCardVersions = ref<Array<string>>(["v3", "v4"]);

const qrcreate = useQrCreateStore();
const qrstyle = useQrStyle();
const cardVersion = ref<string>("v4");
const validateVee = ref(false);
const imageData = ref<string>("");
const Cards = ref<Array<CardGroup>>([
  {
    name: "Identification",
    fields: [
      {
        name: "Name",
        type: "text",
        value: "",
        status: true,
        required: true,
        default: true,
      },
      {
        name: "Email",
        type: "email",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Phone",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Fax",
        type: "text",
        value: "",
        status: false,
      },
      {
        name: "Gender",
        type: "select",
        value: "Female",
        status: false,
        options: ["Male", "Female", "Other"],
      },
      {
        name: "Nickname",
        type: "text",
        value: "",
        status: false,
      },
      {
        name: "Birthday",
        type: "date",
        value: "",
        status: false,
      },
      {
        name: "Birthplace",
        type: "text",
        value: "",
        status: false,
      },
      {
        name: "Hobby",
        type: "text",
        value: "",
        status: false,
      },
    ],
  },
  {
    name: "Organizational",
    fields: [
      {
        name: "Company",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Position",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Work Email",
        type: "email",
        value: "",
        status: false,
      },
      {
        name: "Work Phone",
        type: "text",
        value: "",
        status: false,
      },
    ],
  },
  {
    name: "Information",
    fields: [
      {
        name: "Street",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "City",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Region",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Zipcode",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Country",
        type: "text",
        value: "",
        status: true,
        default: true,
      },
      {
        name: "Geolocation",
        type: "text",
        placeholder: "21.65,17.44",
        value: "",
        status: false,
      },
      {
        name: "Website",
        type: "text",
        value: "",
        placeholder: "http://example.com",
        status: false,
      },
      {
        name: "Note",
        type: "text",
        value: "",
        status: false,
      },
      {
        name: "Language",
        type: "text",
        value: "",
        placeholder: "en-US",
        status: false,
      },
    ],
  },
]);

const BuildCardV4 = () => {
  qrcreate.vcard.vcard = "";
  validateVee.value = true;
  if (!Cards.value[0].fields[0].value) {
    return "";
  }
  const fields: Array<FieldCard> = [];
  Cards.value.forEach((card) => {
    card.fields.forEach((field) => {
      if (field.value) {
        fields.push(field);
      }
    });
  });
  var dataCard = [];
  const name = findValueByName(fields, "Name");
  const fn = new FNProperty([], new TextType(name));
  dataCard.push(fn);
  // var nArr = Array(5)
  // name.split(' ').forEach(item => nArr.push(new TextType(item)));
  // const n = new NProperty(nArr, new SpecialValueType(, "NProperty"));
  const email = findValueByName(fields, "Email");
  if (email) {
    dataCard.push(new EmailProperty([], new TextType(email)));
  }
  const tel = findValueByName(fields, "Phone");
  if (tel) {
    dataCard.push(
      new TelProperty(
        [new TypeParameter(new TextType("home"), "TelProperty")],
        new TextType(tel)
      )
    );
  }
  const fax = findValueByName(fields, "Fax");
  if (fax) {
    dataCard.push(
      new TelProperty(
        [new TypeParameter(new TextType("fax"), "TelProperty")],
        new TextType(fax)
      )
    );
  }
  if (imageData.value) {
    dataCard.push(new PhotoProperty([], new URIType(imageData.value)));
  }
  const gender = findValueByName(fields, "Gender").charAt(0);
  if (gender) {
    dataCard.push(new GenderProperty([], new SexType(gender)));
  }

  const nickname = findValueByName(fields, "Nickname");
  if (nickname) {
    dataCard.push(new NicknameProperty([], new TextType(nickname)));
  }
  const bday = findValueByName(fields, "Birthday");
  if (bday) {
    dataCard.push(
      new BdayProperty(
        [],
        new DateTimeType(moment(bday).format("YYYYMMDD"), "dateandortime")
      )
    );
  }

  const bplace = findValueByName(fields, "Birthplace");
  if (bplace) {
    dataCard.push(new BirthPlaceProperty([], new TextType(bplace)));
  }
  const hobby = findValueByName(fields, "Hobby");
  if (hobby) {
    dataCard.push(new HobbyProperty([], new TextType(hobby)));
  }

  const addrArr = new Array(7);
  addrArr[2] = new TextType(findValueByName(fields, "Street"));
  addrArr[3] = new TextType(findValueByName(fields, "City"));
  addrArr[4] = new TextType(findValueByName(fields, "Region"));
  addrArr[5] = new TextType(findValueByName(fields, "Zipcode"));
  addrArr[6] = new TextType(findValueByName(fields, "Country"));

  dataCard.push(
    new AdrProperty([], new SpecialValueType(addrArr, "AdrProperty"))
  );
  var website = findValueByName(fields, "Website");
  if (website) {
    if (!website.includes("http")) {
      website = "http://" + website;
    }
    dataCard.push(new URLProperty([], new URIType(website)));
  }

  const geo = findValueByName(fields, "Geolocation");
  if (geo) {
    dataCard.push(new GeoProperty([], new URIType("geo:" + geo)));
  }
  const note = findValueByName(fields, "Note");
  if (note) {
    dataCard.push(new NoteProperty([], new TextType(note)));
  }
  const language = findValueByName(fields, "Language");
  if (language) {
    dataCard.push(new LangProperty([], new TextType(language)));
  }
  // organization

  var dataGroup = [];
  const oz_email = findValueByName(fields, "Work Email");
  if (oz_email) {
    dataGroup.push(
      new EmailProperty(
        [new TypeParameter(new TextType("work"), "EmailProperty")],
        new TextType(oz_email)
      )
    );
  }
  const oz_tel = findValueByName(fields, "Work Phone");
  if (oz_tel) {
    dataGroup.push(
      new TelProperty(
        [new TypeParameter(new TextType("work"), "TelProperty")],
        new TextType(oz_tel)
      )
    );
  }

  const oz = findValueByName(fields, "Company");
  if (oz) {
    dataGroup.push(
      new OrgProperty(
        [],
        new SpecialValueType([new TextType(oz)], "orgproperty")
      )
    );
  }

  const oz_role = findValueByName(fields, "Position");
  if (oz_role) {
    dataGroup.push(new RoleProperty([], new TextType(oz_role)));
  }

  // if (dataGroup.length) {
  //     dataCard.push(new Group(dataGroup, "job"));
  // }
  const card = new VCARD([...dataCard, ...dataGroup]);
  qrcreate.vcard.vcard = card.repr();
};

const GenerateQrCode = () => {
  BuildCardV4();
  if (qrcreate.vcard.vcard) {
    qrstyle.GenerateQrCode();
  }
};
const DownloadVcard = () => {
  BuildCardV4();
  if (qrcreate.vcard.vcard) {
    const url = window.URL.createObjectURL(
      new Blob([qrcreate.vcard.vcard], { type: "text/x-vcard" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "qr_gateway_vcard_" + Date.now() + ".vcf");
    document.body.appendChild(link);
    link.click();
  }
};

const findValueByName = (fields: Array<FieldCard>, name: string): string => {
  for (let i = 0; i < fields.length; i++) {
    if (fields[i].name == name) {
      return fields[i].value ?? "";
    }
  }
  return "";
};

const file = ref<HTMLElement>();
const utils = useUtils();
const nest = useNest();
const chooseAvatar = () => {
  file.value?.click();
};
const config = useRuntimeConfig();
const changeAvatar = async (e: Event) => {
  const files = (e.target as HTMLInputElement).files;
  const imageFile = files?.item(0) as File;
  const formdata = new FormData();
  formdata.append("file", imageFile);
  //@ts-ignore
  const response: { path: string } = await $fetch(
    config.public.app_nest_url + "/upload/image",
    {
      method: "POST",
      body: formdata,
    }
  );
  imageData.value = nest.StaticFileUrl(response);

  // imageData.value = (await utils.fileToBase64(imageFile));
};
const clearField = (field: FieldCard) => {
  field.status = false;
  field.value = "";
};
</script>
<style lang="scss">
.required {
  &::after {
    content: "*";
    margin-left: 4px;
    color: red;
  }
}
</style>
